/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages


          var seenLeave = false;
          if(!getCookie('leavemessage')) {
              jQuery(document).bind("mouseleave", function (e) {

                  // Dont show it more than once per visit
                  if(seenLeave) return;

                  if (e.pageY - jQuery(window).scrollTop() <= 1) {
                      seenLeave = true;
                      jQuery('#exit-modal').modal();
                      setCookie('leavemessage','1');
                  }
              });
          }


          var width  = jQuery(window).width();
          var headHeight = jQuery('.banner').outerHeight();

          jQuery('.cbp-spmenu-right').css('right', 0 - width);
          jQuery('.cbp-spmenu-right').css('top', 0 + headHeight + 20);


          $(".owl-carousel").owlCarousel({
              loop: true,
              margin: 0,
              autoWidth: false,
              nav: false,
              dots: true,
              items: 1,
              autoplay: true
          });

          $("#home.owl-carousel").owlCarousel({
              loop: true,
              margin: 0,
              autoWidth: false,
              nav: false,
              dots: true,
              items: 1,
              autoplay: true
          });


          $i = 0;

          $('.hamburger').click(function(){

              $(this).toggleClass('is-active');

              $i++;

              if ($i == 1) {

                  $('body').addClass('stopScroll');

              }

              if ($i == 2) {

                $('body').removeClass('stopScroll');

                $i = 0;

              }

          });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
